import { createSelector } from 'reselect'
import _ from 'lodash';

export const usersList = (state) => state.users.users;




// WEBPACK FOOTER //
// ./src/storeState/users/selectors.js